import { FC, MouseEvent, useState } from 'react';
import s from './tabs.module.scss';
import cn from 'classnames';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import { useTranslation } from '@hooks/useTranslation';
import { ITabItem } from '@specs/types';
import Link from 'next/link';
import { useRouter } from 'next/router';
interface Props extends ITabItem {}
export const TabItem: FC<Props> = ({
  isActive,
  icon,
  text,
  onClick,
  href,
  ...props
}) => {
  const router = useRouter();
  const {
    translate: tr
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const clickHandler = async (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (isActive) return;
    setIsLoading(true);
    await onClick?.(e);
    await router.push(href);
    setIsLoading(false);
  };
  return <Link className={cn(s.tabItem, isLoading && s.tabItem_loading, isActive && s.tabItem_active)} onClick={clickHandler} href={href} {...props} data-sentry-element="Link" data-sentry-component="TabItem" data-sentry-source-file="TabItem.tsx">
            <div className={s.tabItem__body}>
                {typeof icon !== 'undefined' && <SpriteIcon {...icon} width={20} height={20} />}
                <span>
                {tr({
          id: text
        })}
            </span>
            </div>
        </Link>;
};